import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../components/common/Loader";

export default function KeycloakSignIn() {
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();

  useEffect(() => {
    if (!keycloak.authenticated) {
      localStorage.clear();
      keycloak.login({ redirectUri: window.location.origin + "/" });
    } else {
      keycloak.logout();
    }
  }, [keycloak, navigate]);

  return <Loader />;
}
